import { safeStorage } from './safeStorage';

/**
 * Authenticated fetch wrapper.
 * Adds the JWT Authorization header from safeStorage alongside credentials: 'include'.
 * This ensures requests work both with cookies AND localStorage tokens
 * (critical for mobile Safari which drops cross-site cookies, and for
 * iOS Private Browsing which disables localStorage — safeStorage falls back
 * to in-memory storage in that case).
 */
export async function authFetch(url, options = {}) {
  const token = safeStorage.getItem('token');
  const headers = { ...(options.headers || {}) };
  if (token && !headers['Authorization']) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(url, {
    ...options,
    credentials: 'include',
    headers,
  });
}
